import { render } from "./DiagramSettings.vue?vue&type=template&id=52a1bf88&scoped=true"
import script from "./DiagramSettings.vue?vue&type=script&lang=ts"
export * from "./DiagramSettings.vue?vue&type=script&lang=ts"

import "./DiagramSettings.vue?vue&type=style&index=0&id=52a1bf88&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-52a1bf88"

export default script